module.exports = __webpack_public_path__ + "static/img/tabphone2.34629118.png";